module.exports = __webpack_public_path__ + "static/세제-d1fcd8560b3db995fdca09b63cb21096.jpg";